export const GET_ARTICLES_LIST = "GET_ARTICLES_LIST";
export const GET_ARTICLES_HEADER = "GET_ARTICLES_HEADER";
export const GET_CLIENTS_HEADER = "GET_CLIENTS_HEADER";
export const CHANGE_SUBMENU_LIST = "CHANGE_SUBMENU_LIST";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const GET_CLIENTS_LIST = "GET_CLIENTS_LIST";
export const AFFICHE_DATA_TABLE = "AFFICHE_DATA_TABLE";
export const GET_ELEMENT_DETAILS = "GET_ELEMENT_DETAILS";
export const GET_Article_DETAILS = "GET_Article_DETAILS";
export const GET_CLIENT_DETAILS = "GET_CLIENT_DETAILS";
export const REMPLIR_DATA_TABLE = "REMPLIR_DATA_TABLE";
export const SEARCHING = "SEARCHING";
export const GET_FOURNISSEURS_HEADER = "GET_FOURNISSEURS_HEADER";
export const GET_FOURNISSEURS_LIST = "GET_FOURNISSEURS_LIST";
export const REMOVE_CLIENT = "REMOVE_CLIENT";
export const POST_CLIENT = "POST_CLIENT";
export const REMOVE_FOURNISSEUR = "REMOVE_FOURNISSEUR";
export const POST_FOURNISSEUR = "POST_FOURNISSEUR";
export const DARCK_MODE = "DARCK_MODE";
